export default __webpack_public_path__ + "static/media/brainGray.b70e1394.svg";